var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-details__type-text",domProps:{"innerHTML":_vm._s(_vm.typeText)}})
}
var staticRenderFns = []

export { render, staticRenderFns }